import { SuggestionItem } from './types';

/**
 * Filters and scores suggestions against user input text.
 *
 * Scoring:
 *  - label startsWith query: +100
 *  - label includes query:   +75
 *  - any keyword includes query: +50
 *  - description includes query: +25
 *
 * Returns matched items sorted by descending score.
 * Does not mutate the original array.
 */ 
export function filterSuggestions(
  inputText: string,
  suggestions: SuggestionItem[],
): SuggestionItem[] {
  if (!inputText.trim()) return suggestions;

  const query = inputText.toLowerCase().trim();

  const scored = suggestions
    .map((item) => {
      let score = 0;
      const label = item.label.toLowerCase();
      const desc = item.description.toLowerCase();

      if (label.startsWith(query)) score += 100;
      else if (label.includes(query)) score += 75;

      if (item.keywords.some((k) => k.toLowerCase().includes(query))) score += 50;

      if (desc.includes(query)) score += 25;

      return { item, score };
    })
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score);

  return scored.map(({ item }) => item);
}
